// This file is auto-generated by @hey-api/openapi-ts

import { createClient, createConfig, type Options, formDataBodySerializer } from '@hey-api/client-fetch';
import type { GetHealthError, GetHealthResponse, GetAuthConfigError, GetAuthConfigResponse, RootError, RootResponse, GetMeError, GetMeResponse, ListSessionsData, ListSessionsError, ListSessionsResponse, CreateSessionData, CreateSessionError, CreateSessionResponse, UpdateSessionData, UpdateSessionError, UpdateSessionResponse, DeleteSessionData, DeleteSessionError, DeleteSessionResponse, ListSessionMessagesData, ListSessionMessagesError, ListSessionMessagesResponse, GetContextStatusData, GetContextStatusError, GetContextStatusResponse, LoginData, LoginError, LoginResponse2, RegisterData, RegisterError, RegisterResponse2, SetupAdminData, SetupAdminError, SetupAdminResponse, GetStatusError, GetStatusResponse, GetSetupPlanError, GetSetupPlanResponse, SaveSetupStepData, SaveSetupStepError, SaveSetupStepResponse, ConfigureLlmData, ConfigureLlmError, ConfigureLlmResponse, CompleteError, CompleteResponse, GetSettingsSnapshotError, GetSettingsSnapshotResponse, PatchSettingsData, PatchSettingsError, PatchSettingsResponse, GetMaskedSecretData, GetMaskedSecretError, GetMaskedSecretResponse, DeleteSecretData, DeleteSecretError, DeleteSecretResponse, PutSecretData, PutSecretError, PutSecretResponse, TestConnectionData, TestConnectionError, TestConnectionResponse2, CreateBackupError, CreateBackupResponse, RestoreBackupData, RestoreBackupError, RestoreBackupResponse, ListTierPoliciesError, ListTierPoliciesResponse, GetTierPolicyData, GetTierPolicyError, GetTierPolicyResponse, UpdateTierPolicyData, UpdateTierPolicyError, UpdateTierPolicyResponse, GetUserPolicyData, GetUserPolicyError, GetUserPolicyResponse, SetUserOverrideData, SetUserOverrideError, SetUserOverrideResponse, ClearUserOverrideData, ClearUserOverrideError, ClearUserOverrideResponse, ListDefaultTierPoliciesError, ListDefaultTierPoliciesResponse, ListUsersData, ListUsersError, ListUsersResponse, PromoteUserData, PromoteUserError, PromoteUserResponse, DemoteUserData, DemoteUserError, DemoteUserResponse, GetModelPolicyError, GetModelPolicyResponse, PutModelPolicyData, PutModelPolicyError, PutModelPolicyResponse, ListControlsError, ListControlsResponse, PreviewControlsData, PreviewControlsError, PreviewControlsResponse, PutControlData, PutControlError, PutControlResponse, DeleteControlData, DeleteControlError, DeleteControlResponse, ControlHistoryData, ControlHistoryError, ControlHistoryResponse, UndoControlChangeData, UndoControlChangeError, UndoControlChangeResponse, ListCohortsError, ListCohortsResponse, CreateCohortData, CreateCohortError, CreateCohortResponse, UpdateCohortData, UpdateCohortError, UpdateCohortResponse, DeleteCohortData, DeleteCohortError, DeleteCohortResponse, MyControlsError, MyControlsResponse, ExportAuditLogData, ExportAuditLogError, ExportAuditLogResponse, GetMyUsageError, GetMyUsageResponse, GetMyUsageDetailError, GetMyUsageDetailResponse, AdminGetUsageData, AdminGetUsageError, AdminGetUsageResponse, AdminSetTierData, AdminSetTierError, AdminSetTierResponse, ListAgentsError, ListAgentsResponse, CreateAgentData, CreateAgentError, CreateAgentResponse, GetAgentData, GetAgentError, GetAgentResponse, UpdateAgentData, UpdateAgentError, UpdateAgentResponse, DeleteAgentData, DeleteAgentError, DeleteAgentResponse, RunAgentData, RunAgentError, RunAgentResponse, ListRunsError, ListRunsResponse, GetRunData, GetRunError, GetRunResponse, CancelRunData, CancelRunError, CancelRunResponse, ListTasksData, ListTasksError, ListTasksResponse, GetTaskData, GetTaskError, GetTaskResponse, ListTaskEventsData, ListTaskEventsError, ListTaskEventsResponse, CancelTaskData, CancelTaskError, CancelTaskResponse, MarkTaskReportedData, MarkTaskReportedError, MarkTaskReportedResponse, InitiateUploadData, InitiateUploadError, InitiateUploadResponse, ListArtifactsData, ListArtifactsError, ListArtifactsResponse, ReadArtifactData, ReadArtifactError, ReadArtifactResponse, DeleteArtifactData, DeleteArtifactError, DeleteArtifactResponse, FinalizeUploadData, FinalizeUploadError, FinalizeUploadResponse, GetStorageStatsError, GetStorageStatsResponse, GetAdminStorageOverviewError, GetAdminStorageOverviewResponse, WriteFactData, WriteFactError, WriteFactResponse, ListFactsData, ListFactsError, ListFactsResponse, ForgetFactData, ForgetFactError, ForgetFactResponse, RecallMemoryData, RecallMemoryError, RecallMemoryResponse, RegisterDeviceData, RegisterDeviceError, RegisterDeviceResponse, ListDevicesError, ListDevicesResponse, GetDeviceData, GetDeviceError, GetDeviceResponse, DeleteDeviceData, DeleteDeviceError, DeleteDeviceResponse, EnrolDeviceData, EnrolDeviceError, EnrolDeviceResponse, ListSkillsError, ListSkillsResponse, UploadSkillData, UploadSkillError, UploadSkillResponse, SearchSkillHubData, SearchSkillHubError, SearchSkillHubResponse, PreviewHubSkillData, PreviewHubSkillError, PreviewHubSkillResponse, InstallSkillData, InstallSkillError, InstallSkillResponse, DeleteSkillData, DeleteSkillError, DeleteSkillResponse, ListSkillUpdatesError, ListSkillUpdatesResponse, ListToolsError, ListToolsResponse, GetToolsManifestData, GetToolsManifestError, GetToolsManifestResponse, GetToolData, GetToolError, GetToolResponse, InvokeToolData, InvokeToolError, InvokeToolResponse, GetToolRunData, GetToolRunError, GetToolRunResponse, CancelToolRunData, CancelToolRunError, CancelToolRunResponse, ListCredentialsError, ListCredentialsResponse, CreateCredentialData, CreateCredentialError, CreateCredentialResponse, DeleteCredentialData, DeleteCredentialError, DeleteCredentialResponse, GetModelOptionsError, GetModelOptionsResponse, GetModelPreferenceError, GetModelPreferenceResponse, PutModelPreferenceData, PutModelPreferenceError, PutModelPreferenceResponse, GetOrchestrationPreferenceError, GetOrchestrationPreferenceResponse, PutOrchestrationPreferenceData, PutOrchestrationPreferenceError, PutOrchestrationPreferenceResponse, GetChatPreferenceError, GetChatPreferenceResponse, PutChatPreferenceData, PutChatPreferenceError, PutChatPreferenceResponse, GetMyProfileError, GetMyProfileResponse, PutMyProfileData, PutMyProfileError, PutMyProfileResponse, GetDesktopError, GetDesktopResponse, StartDesktopData, StartDesktopError, StartDesktopResponse, StopDesktopError, StopDesktopResponse, LaunchInDesktopData, LaunchInDesktopError, LaunchInDesktopResponse, ListTilesError, ListTilesResponse, CreateTileData, CreateTileError, CreateTileResponse, ClearTilesData, ClearTilesError, ClearTilesResponse, UpdateTileData, UpdateTileError, UpdateTileResponse, DeleteTileData, DeleteTileError, DeleteTileResponse, PaneEventsError, PaneEventsResponse, ListProjectsError, ListProjectsResponse, CreateProjectData, CreateProjectError, CreateProjectResponse, GetProjectData, GetProjectError, GetProjectResponse, UpdateProjectData, UpdateProjectError, UpdateProjectResponse, DeleteProjectData, DeleteProjectError, DeleteProjectResponse, ListProjectFilesData, ListProjectFilesError, ListProjectFilesResponse, AddProjectFileData, AddProjectFileError, AddProjectFileResponse, RemoveProjectFileData, RemoveProjectFileError, RemoveProjectFileResponse, GetMcpCatalogError, GetMcpCatalogResponse, ListInstalledMcpsError, ListInstalledMcpsResponse, InstallMcpData, InstallMcpError, InstallMcpResponse, UninstallMcpData, UninstallMcpError, UninstallMcpResponse, ReloadMcpData, ReloadMcpError, ReloadMcpResponse, GetVoiceStatusError, GetVoiceStatusResponse, StartVoiceCallData, StartVoiceCallError, StartVoiceCallResponse, StartDeviceVoiceCallData, StartDeviceVoiceCallError, StartDeviceVoiceCallResponse, RtcOfferData, RtcOfferError, RtcOfferResponse2, ListInputsError, ListInputsResponse, ResolveInputData, ResolveInputError, ResolveInputResponse, ListNotificationsData, ListNotificationsError, ListNotificationsResponse, MarkNotificationReadData, MarkNotificationReadError, MarkNotificationReadResponse, GetPreferencesError, GetPreferencesResponse, PatchPreferencesData, PatchPreferencesError, PatchPreferencesResponse, GetPushConfigError, GetPushConfigResponse, SubscribePushData, SubscribePushError, SubscribePushResponse, UnsubscribePushData, UnsubscribePushError, UnsubscribePushResponse, CreateRideSessionData, CreateRideSessionError, CreateRideSessionResponse, ListRideSessionsData, ListRideSessionsError, ListRideSessionsResponse, GetRideSessionData, GetRideSessionError, GetRideSessionResponse, CancelRideSessionData, CancelRideSessionError, CancelRideSessionResponse, RetryRideStepData, RetryRideStepError, RetryRideStepResponse, ListWorkflowsData, ListWorkflowsError, ListWorkflowsResponse, CreateWorkflowData, CreateWorkflowError, CreateWorkflowResponse, UpdateWorkflowData, UpdateWorkflowError, UpdateWorkflowResponse, DeleteWorkflowData, DeleteWorkflowError, DeleteWorkflowResponse, TriggerWorkflowData, TriggerWorkflowError, TriggerWorkflowResponse, ListWorkflowRunsData, ListWorkflowRunsError, ListWorkflowRunsResponse, GetWorkflowRunData, GetWorkflowRunError, GetWorkflowRunResponse, ListWorkflowRunStepsData, ListWorkflowRunStepsError, ListWorkflowRunStepsResponse, ValidateWorkflowData, ValidateWorkflowError, ValidateWorkflowResponse, GenerateWorkflowData, GenerateWorkflowError, GenerateWorkflowResponse, PublicStatusError, PublicStatusResponse, AdminSlosError, AdminSlosResponse, AdminCostsData, AdminCostsError, AdminCostsResponse, AdminAuditData, AdminAuditError, AdminAuditResponse, VerifyAuditChainError, VerifyAuditChainResponse, AdminProfileError, AdminProfileResponse, WebhookAgentDoneData, WebhookAgentDoneError, WebhookAgentDoneResponse, ListOrchestrationAgentsError, ListOrchestrationAgentsResponse, GetAgentWikiData, GetAgentWikiError, GetAgentWikiResponse } from './types.gen';

export const client = createClient(createConfig());

/**
 * liveness probe
 */
export const getHealth = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetHealthResponse, GetHealthError, ThrowOnError>({
        ...options,
        url: '/api/v1/health'
    });
};

/**
 * Get Auth Config
 */
export const getAuthConfig = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAuthConfigResponse, GetAuthConfigError, ThrowOnError>({
        ...options,
        url: '/api/v1/auth/config'
    });
};

/**
 * service identity probe
 * Tiny JSON identity payload — no sensitive data, no auth required.
 */
export const root = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<RootResponse, RootError, ThrowOnError>({
        ...options,
        url: '/'
    });
};

/**
 * who am i
 */
export const getMe = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetMeResponse, GetMeError, ThrowOnError>({
        ...options,
        url: '/api/v1/me'
    });
};

/**
 * list my sessions
 */
export const listSessions = <ThrowOnError extends boolean = false>(options?: Options<ListSessionsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListSessionsResponse, ListSessionsError, ThrowOnError>({
        ...options,
        url: '/api/v1/sessions'
    });
};

/**
 * create a session
 */
export const createSession = <ThrowOnError extends boolean = false>(options: Options<CreateSessionData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateSessionResponse, CreateSessionError, ThrowOnError>({
        ...options,
        url: '/api/v1/sessions'
    });
};

/**
 * update session metadata (title, project)
 * Partial: only the fields sent change. Renaming does not move the chat
 * and moving it does not clear its title; ``project_id: null`` moves it out.
 */
export const updateSession = <ThrowOnError extends boolean = false>(options: Options<UpdateSessionData, ThrowOnError>) => {
    return (options?.client ?? client).patch<UpdateSessionResponse, UpdateSessionError, ThrowOnError>({
        ...options,
        url: '/api/v1/sessions/{session_id}'
    });
};

/**
 * delete a session and its messages
 */
export const deleteSession = <ThrowOnError extends boolean = false>(options: Options<DeleteSessionData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteSessionResponse, DeleteSessionError, ThrowOnError>({
        ...options,
        url: '/api/v1/sessions/{session_id}'
    });
};

/**
 * list messages for a session
 * Return up to ``limit`` messages for the session in chronological order.
 *
 * IDOR-safe: the session must belong to the authenticated user.
 * Uses cursor-based pagination — pass the ``id`` of the oldest returned
 * message as ``before_id`` to fetch the previous page.
 */
export const listSessionMessages = <ThrowOnError extends boolean = false>(options: Options<ListSessionMessagesData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListSessionMessagesResponse, ListSessionMessagesError, ThrowOnError>({
        ...options,
        url: '/api/v1/sessions/{session_id}/messages'
    });
};

/**
 * current ADK auto-compaction state for a session
 * Surface the live context-usage gauge for a session.
 *
 * Feeds the dashboard's circular progress indicator (FU-2): the
 * manual ``/compact`` endpoint retired alongside the custom
 * summarizer; the user now sees ADK's auto-compaction firing
 * naturally + a real-value ring showing how full the context is
 * relative to the configured token threshold.
 *
 * The estimate matches ADK's heuristic (~4 chars / token) so the
 * ring tracks the same number the model's compactor uses
 * server-side to decide when to fire.
 */
export const getContextStatus = <ThrowOnError extends boolean = false>(options: Options<GetContextStatusData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetContextStatusResponse, GetContextStatusError, ThrowOnError>({
        ...options,
        url: '/api/v1/sessions/{session_id}/context-status'
    });
};

/**
 * Login
 */
export const login = <ThrowOnError extends boolean = false>(options: Options<LoginData, ThrowOnError>) => {
    return (options?.client ?? client).post<LoginResponse2, LoginError, ThrowOnError>({
        ...options,
        url: '/api/v1/auth/login'
    });
};

/**
 * Register
 */
export const register = <ThrowOnError extends boolean = false>(options: Options<RegisterData, ThrowOnError>) => {
    return (options?.client ?? client).post<RegisterResponse2, RegisterError, ThrowOnError>({
        ...options,
        url: '/api/v1/auth/register'
    });
};

/**
 * Setup Admin
 */
export const setupAdmin = <ThrowOnError extends boolean = false>(options: Options<SetupAdminData, ThrowOnError>) => {
    return (options?.client ?? client).post<SetupAdminResponse, SetupAdminError, ThrowOnError>({
        ...options,
        url: '/api/v1/setup/admin'
    });
};

/**
 * Get Status
 */
export const getStatus = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetStatusResponse, GetStatusError, ThrowOnError>({
        ...options,
        url: '/api/v1/setup/status'
    });
};

/**
 * Get Setup Plan
 */
export const getSetupPlan = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetSetupPlanResponse, GetSetupPlanError, ThrowOnError>({
        ...options,
        url: '/api/v1/setup/plan'
    });
};

/**
 * Save Setup Step
 */
export const saveSetupStep = <ThrowOnError extends boolean = false>(options: Options<SaveSetupStepData, ThrowOnError>) => {
    return (options?.client ?? client).post<SaveSetupStepResponse, SaveSetupStepError, ThrowOnError>({
        ...options,
        url: '/api/v1/setup/step'
    });
};

/**
 * Configure Llm
 */
export const configureLlm = <ThrowOnError extends boolean = false>(options: Options<ConfigureLlmData, ThrowOnError>) => {
    return (options?.client ?? client).post<ConfigureLlmResponse, ConfigureLlmError, ThrowOnError>({
        ...options,
        url: '/api/v1/setup/llm'
    });
};

/**
 * Complete
 */
export const complete = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).post<CompleteResponse, CompleteError, ThrowOnError>({
        ...options,
        url: '/api/v1/setup/complete'
    });
};

/**
 * Get Settings Snapshot
 */
export const getSettingsSnapshot = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetSettingsSnapshotResponse, GetSettingsSnapshotError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/settings'
    });
};

/**
 * Patch Settings
 */
export const patchSettings = <ThrowOnError extends boolean = false>(options: Options<PatchSettingsData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PatchSettingsResponse, PatchSettingsError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/settings'
    });
};

/**
 * Get Masked Secret
 */
export const getMaskedSecret = <ThrowOnError extends boolean = false>(options: Options<GetMaskedSecretData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetMaskedSecretResponse, GetMaskedSecretError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/settings/secrets/{name}'
    });
};

/**
 * Delete Secret
 */
export const deleteSecret = <ThrowOnError extends boolean = false>(options: Options<DeleteSecretData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteSecretResponse, DeleteSecretError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/settings/secrets/{name}'
    });
};

/**
 * Put Secret
 */
export const putSecret = <ThrowOnError extends boolean = false>(options: Options<PutSecretData, ThrowOnError>) => {
    return (options?.client ?? client).put<PutSecretResponse, PutSecretError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/settings/secrets'
    });
};

/**
 * Test Connection
 * Probe an external integration with the supplied (or current) config.
 *
 * The probe runs **read-only** — e.g. ``HEAD`` on the LLM base URL,
 * ``EHLO`` on the SMTP host, ``ListBuckets`` on S3. Failures are
 * reported as a 200 response with ``ok=false`` so the dashboard can
 * show a friendly error without retrying.
 */
export const testConnection = <ThrowOnError extends boolean = false>(options: Options<TestConnectionData, ThrowOnError>) => {
    return (options?.client ?? client).post<TestConnectionResponse2, TestConnectionError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/settings/test-connection'
    });
};

/**
 * Create Backup
 */
export const createBackup = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateBackupResponse, CreateBackupError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/backup'
    });
};

/**
 * Restore Backup
 */
export const restoreBackup = <ThrowOnError extends boolean = false>(options: Options<RestoreBackupData, ThrowOnError>) => {
    return (options?.client ?? client).post<RestoreBackupResponse, RestoreBackupError, ThrowOnError>({
        ...options,
        ...formDataBodySerializer,
        headers: {
            'Content-Type': null,
            ...options?.headers
        },
        url: '/api/v1/admin/restore'
    });
};

/**
 * List Tier Policies
 */
export const listTierPolicies = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<ListTierPoliciesResponse, ListTierPoliciesError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/policies/tiers'
    });
};

/**
 * Get Tier Policy
 */
export const getTierPolicy = <ThrowOnError extends boolean = false>(options: Options<GetTierPolicyData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetTierPolicyResponse, GetTierPolicyError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/policies/tiers/{tier}'
    });
};

/**
 * Update Tier Policy
 */
export const updateTierPolicy = <ThrowOnError extends boolean = false>(options: Options<UpdateTierPolicyData, ThrowOnError>) => {
    return (options?.client ?? client).put<UpdateTierPolicyResponse, UpdateTierPolicyError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/policies/tiers/{tier}'
    });
};

/**
 * Get User Policy
 */
export const getUserPolicy = <ThrowOnError extends boolean = false>(options: Options<GetUserPolicyData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetUserPolicyResponse, GetUserPolicyError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/policies/users/{user_id}'
    });
};

/**
 * Set User Override
 */
export const setUserOverride = <ThrowOnError extends boolean = false>(options: Options<SetUserOverrideData, ThrowOnError>) => {
    return (options?.client ?? client).put<SetUserOverrideResponse, SetUserOverrideError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/policies/users/{user_id}/override'
    });
};

/**
 * Clear User Override
 */
export const clearUserOverride = <ThrowOnError extends boolean = false>(options: Options<ClearUserOverrideData, ThrowOnError>) => {
    return (options?.client ?? client).delete<ClearUserOverrideResponse, ClearUserOverrideError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/policies/users/{user_id}/override'
    });
};

/**
 * List Default Tier Policies
 */
export const listDefaultTierPolicies = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<ListDefaultTierPoliciesResponse, ListDefaultTierPoliciesError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/policies/defaults'
    });
};

/**
 * List Users
 */
export const listUsers = <ThrowOnError extends boolean = false>(options?: Options<ListUsersData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListUsersResponse, ListUsersError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/users'
    });
};

/**
 * Promote User
 */
export const promoteUser = <ThrowOnError extends boolean = false>(options: Options<PromoteUserData, ThrowOnError>) => {
    return (options?.client ?? client).post<PromoteUserResponse, PromoteUserError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/users/{user_id}/promote'
    });
};

/**
 * Demote User
 */
export const demoteUser = <ThrowOnError extends boolean = false>(options: Options<DemoteUserData, ThrowOnError>) => {
    return (options?.client ?? client).post<DemoteUserResponse, DemoteUserError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/users/{user_id}/demote'
    });
};

/**
 * model policy
 */
export const getModelPolicy = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetModelPolicyResponse, GetModelPolicyError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/models'
    });
};

/**
 * set the model policy
 */
export const putModelPolicy = <ThrowOnError extends boolean = false>(options: Options<PutModelPolicyData, ThrowOnError>) => {
    return (options?.client ?? client).put<PutModelPolicyResponse, PutModelPolicyError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/models'
    });
};

/**
 * all controls with their stored settings
 */
export const listControls = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<ListControlsResponse, ListControlsError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/controls'
    });
};

/**
 * what applies to one person
 */
export const previewControls = <ThrowOnError extends boolean = false>(options: Options<PreviewControlsData, ThrowOnError>) => {
    return (options?.client ?? client).get<PreviewControlsResponse, PreviewControlsError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/controls/preview'
    });
};

/**
 * set a control for everyone, a plan, a group or a person
 */
export const putControl = <ThrowOnError extends boolean = false>(options: Options<PutControlData, ThrowOnError>) => {
    return (options?.client ?? client).put<PutControlResponse, PutControlError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/controls/{key}'
    });
};

/**
 * remove one setting; the layer below applies again
 */
export const deleteControl = <ThrowOnError extends boolean = false>(options: Options<DeleteControlData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteControlResponse, DeleteControlError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/controls/{key}'
    });
};

/**
 * every change to a control, newest first
 */
export const controlHistory = <ThrowOnError extends boolean = false>(options: Options<ControlHistoryData, ThrowOnError>) => {
    return (options?.client ?? client).get<ControlHistoryResponse, ControlHistoryError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/controls/{key}/history'
    });
};

/**
 * put a setting back the way it was before a change
 */
export const undoControlChange = <ThrowOnError extends boolean = false>(options: Options<UndoControlChangeData, ThrowOnError>) => {
    return (options?.client ?? client).post<UndoControlChangeResponse, UndoControlChangeError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/controls/{key}/undo'
    });
};

/**
 * the groups
 */
export const listCohorts = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<ListCohortsResponse, ListCohortsError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/cohorts'
    });
};

/**
 * create a group
 */
export const createCohort = <ThrowOnError extends boolean = false>(options: Options<CreateCohortData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateCohortResponse, CreateCohortError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/cohorts'
    });
};

/**
 * change a group
 */
export const updateCohort = <ThrowOnError extends boolean = false>(options: Options<UpdateCohortData, ThrowOnError>) => {
    return (options?.client ?? client).put<UpdateCohortResponse, UpdateCohortError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/cohorts/{cohort_id}'
    });
};

/**
 * delete a group and its settings
 */
export const deleteCohort = <ThrowOnError extends boolean = false>(options: Options<DeleteCohortData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteCohortResponse, DeleteCohortError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/cohorts/{cohort_id}'
    });
};

/**
 * the controls that apply to me
 */
export const myControls = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<MyControlsResponse, MyControlsError, ThrowOnError>({
        ...options,
        url: '/api/v1/me/controls'
    });
};

/**
 * Export Audit Log
 * Export the audit log as CSV or JSONL. Admin only.
 *
 * Before RW-1.15 this had no admin check and exported
 * ``user_id or <caller>`` — any signed-in user could download anyone's
 * audit log by passing their id. It also read the newest 10,000 entries
 * and *then* applied the dates, so an older range came back short, and
 * held them all in memory while claiming to stream. The dates are now
 * in the query and the store is read a page at a time.
 */
export const exportAuditLog = <ThrowOnError extends boolean = false>(options?: Options<ExportAuditLogData, ThrowOnError>) => {
    return (options?.client ?? client).get<ExportAuditLogResponse, ExportAuditLogError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/audit:export'
    });
};

/**
 * Get My Usage
 */
export const getMyUsage = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetMyUsageResponse, GetMyUsageError, ThrowOnError>({
        ...options,
        url: '/api/v1/billing/me'
    });
};

/**
 * Get My Usage Detail
 * PROD-5b — the real $ budget + itemized spend, in USD and INR.
 *
 * The ledger is always canonically USD (Docs/architecture/27-
 * entitlements-and-billing.md §10); INR is a display-layer
 * conversion applied here, never stored.
 */
export const getMyUsageDetail = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetMyUsageDetailResponse, GetMyUsageDetailError, ThrowOnError>({
        ...options,
        url: '/api/v1/billing/usage'
    });
};

/**
 * Admin Get Usage
 */
export const adminGetUsage = <ThrowOnError extends boolean = false>(options: Options<AdminGetUsageData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminGetUsageResponse, AdminGetUsageError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/billing/{user_id}'
    });
};

/**
 * Admin Set Tier
 */
export const adminSetTier = <ThrowOnError extends boolean = false>(options: Options<AdminSetTierData, ThrowOnError>) => {
    return (options?.client ?? client).put<AdminSetTierResponse, AdminSetTierError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/billing/{user_id}/tier'
    });
};

/**
 * list agents
 */
export const listAgents = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<ListAgentsResponse, ListAgentsError, ThrowOnError>({
        ...options,
        url: '/api/v1/agents'
    });
};

/**
 * create agent
 */
export const createAgent = <ThrowOnError extends boolean = false>(options: Options<CreateAgentData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateAgentResponse, CreateAgentError, ThrowOnError>({
        ...options,
        url: '/api/v1/agents'
    });
};

/**
 * get agent
 */
export const getAgent = <ThrowOnError extends boolean = false>(options: Options<GetAgentData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAgentResponse, GetAgentError, ThrowOnError>({
        ...options,
        url: '/api/v1/agents/{agent_id}'
    });
};

/**
 * update agent
 */
export const updateAgent = <ThrowOnError extends boolean = false>(options: Options<UpdateAgentData, ThrowOnError>) => {
    return (options?.client ?? client).patch<UpdateAgentResponse, UpdateAgentError, ThrowOnError>({
        ...options,
        url: '/api/v1/agents/{agent_id}'
    });
};

/**
 * delete agent
 */
export const deleteAgent = <ThrowOnError extends boolean = false>(options: Options<DeleteAgentData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteAgentResponse, DeleteAgentError, ThrowOnError>({
        ...options,
        url: '/api/v1/agents/{agent_id}'
    });
};

/**
 * create a run for an agent
 */
export const runAgent = <ThrowOnError extends boolean = false>(options: Options<RunAgentData, ThrowOnError>) => {
    return (options?.client ?? client).post<RunAgentResponse, RunAgentError, ThrowOnError>({
        ...options,
        url: '/api/v1/agents/{agent_id}:run'
    });
};

/**
 * list my runs
 */
export const listRuns = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<ListRunsResponse, ListRunsError, ThrowOnError>({
        ...options,
        url: '/api/v1/runs'
    });
};

/**
 * get one run
 */
export const getRun = <ThrowOnError extends boolean = false>(options: Options<GetRunData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetRunResponse, GetRunError, ThrowOnError>({
        ...options,
        url: '/api/v1/runs/{run_id}'
    });
};

/**
 * cancel a run
 */
export const cancelRun = <ThrowOnError extends boolean = false>(options: Options<CancelRunData, ThrowOnError>) => {
    return (options?.client ?? client).post<CancelRunResponse, CancelRunError, ThrowOnError>({
        ...options,
        url: '/api/v1/runs/{run_id}:cancel'
    });
};

/**
 * list my tasks
 */
export const listTasks = <ThrowOnError extends boolean = false>(options?: Options<ListTasksData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListTasksResponse, ListTasksError, ThrowOnError>({
        ...options,
        url: '/api/v1/tasks'
    });
};

/**
 * get one task
 */
export const getTask = <ThrowOnError extends boolean = false>(options: Options<GetTaskData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetTaskResponse, GetTaskError, ThrowOnError>({
        ...options,
        url: '/api/v1/tasks/{task_id}'
    });
};

/**
 * audit timeline for one task
 */
export const listTaskEvents = <ThrowOnError extends boolean = false>(options: Options<ListTaskEventsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListTaskEventsResponse, ListTaskEventsError, ThrowOnError>({
        ...options,
        url: '/api/v1/tasks/{task_id}/events'
    });
};

/**
 * cancel a task — stops its work
 */
export const cancelTask = <ThrowOnError extends boolean = false>(options: Options<CancelTaskData, ThrowOnError>) => {
    return (options?.client ?? client).post<CancelTaskResponse, CancelTaskError, ThrowOnError>({
        ...options,
        url: '/api/v1/tasks/{task_id}/cancel'
    });
};

/**
 * clear the done_unreported flag
 */
export const markTaskReported = <ThrowOnError extends boolean = false>(options: Options<MarkTaskReportedData, ThrowOnError>) => {
    return (options?.client ?? client).post<MarkTaskReportedResponse, MarkTaskReportedError, ThrowOnError>({
        ...options,
        url: '/api/v1/tasks/{task_id}/mark_reported'
    });
};

/**
 * initiate a signed upload
 */
export const initiateUpload = <ThrowOnError extends boolean = false>(options: Options<InitiateUploadData, ThrowOnError>) => {
    return (options?.client ?? client).post<InitiateUploadResponse, InitiateUploadError, ThrowOnError>({
        ...options,
        url: '/api/v1/uploads:initiate'
    });
};

/**
 * list my artifacts
 */
export const listArtifacts = <ThrowOnError extends boolean = false>(options?: Options<ListArtifactsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListArtifactsResponse, ListArtifactsError, ThrowOnError>({
        ...options,
        url: '/api/v1/artifacts'
    });
};

/**
 * signed download URL for an artifact
 */
export const readArtifact = <ThrowOnError extends boolean = false>(options: Options<ReadArtifactData, ThrowOnError>) => {
    return (options?.client ?? client).get<ReadArtifactResponse, ReadArtifactError, ThrowOnError>({
        ...options,
        url: '/api/v1/artifacts/{artifact_id}'
    });
};

/**
 * delete an artifact
 */
export const deleteArtifact = <ThrowOnError extends boolean = false>(options: Options<DeleteArtifactData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteArtifactResponse, DeleteArtifactError, ThrowOnError>({
        ...options,
        url: '/api/v1/artifacts/{artifact_id}'
    });
};

/**
 * confirm an upload completed; hard quota backstop
 * Client calls this after the signed-URL PUT succeeds.
 *
 * ``POST /uploads:initiate``'s quota check trusts the client-declared
 * ``size_bytes`` — soft trust, since the server can't see the PUT
 * (it goes straight to the storage backend, never through the API;
 * see Docs/architecture/06-storage-and-artifacts.md §3). This is the
 * hard backstop: it confirms the object actually landed, reads its
 * *real* size from the object store, and — if a client under-declared
 * at initiate and the true upload pushed the account over quota —
 * deletes the object and refuses rather than letting the overage
 * stand. See Docs/architecture/27-entitlements-and-billing.md §3-4.
 *
 * Idempotent: calling it again after a successful finalize just
 * re-confirms the same object (no double-billing — storage is a
 * gauge computed live from ``storage.list()``, not a counter that
 * could be incremented twice).
 */
export const finalizeUpload = <ThrowOnError extends boolean = false>(options: Options<FinalizeUploadData, ThrowOnError>) => {
    return (options?.client ?? client).post<FinalizeUploadResponse, FinalizeUploadError, ThrowOnError>({
        ...options,
        url: '/api/v1/artifacts/{artifact_id}:finalize'
    });
};

/**
 * per-user storage statistics
 */
export const getStorageStats = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetStorageStatsResponse, GetStorageStatsError, ThrowOnError>({
        ...options,
        url: '/api/v1/storage/stats'
    });
};

/**
 * system-wide storage overview (admin only)
 */
export const getAdminStorageOverview = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAdminStorageOverviewResponse, GetAdminStorageOverviewError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/storage'
    });
};

/**
 * remember a fact
 */
export const writeFact = <ThrowOnError extends boolean = false>(options: Options<WriteFactData, ThrowOnError>) => {
    return (options?.client ?? client).post<WriteFactResponse, WriteFactError, ThrowOnError>({
        ...options,
        url: '/api/v1/memory/facts'
    });
};

/**
 * list my facts
 * One memory at a time: the user's own, or with ``project_id`` that project's.
 */
export const listFacts = <ThrowOnError extends boolean = false>(options?: Options<ListFactsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListFactsResponse, ListFactsError, ThrowOnError>({
        ...options,
        url: '/api/v1/memory/facts'
    });
};

/**
 * forget a fact
 */
export const forgetFact = <ThrowOnError extends boolean = false>(options: Options<ForgetFactData, ThrowOnError>) => {
    return (options?.client ?? client).delete<ForgetFactResponse, ForgetFactError, ThrowOnError>({
        ...options,
        url: '/api/v1/memory/facts/{fact_id}'
    });
};

/**
 * recall facts relevant to a query
 */
export const recallMemory = <ThrowOnError extends boolean = false>(options: Options<RecallMemoryData, ThrowOnError>) => {
    return (options?.client ?? client).post<RecallMemoryResponse, RecallMemoryError, ThrowOnError>({
        ...options,
        url: '/api/v1/memory:recall'
    });
};

/**
 * register (or update) a device
 */
export const registerDevice = <ThrowOnError extends boolean = false>(options: Options<RegisterDeviceData, ThrowOnError>) => {
    return (options?.client ?? client).post<RegisterDeviceResponse, RegisterDeviceError, ThrowOnError>({
        ...options,
        url: '/api/v1/devices/register'
    });
};

/**
 * list my devices
 */
export const listDevices = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<ListDevicesResponse, ListDevicesError, ThrowOnError>({
        ...options,
        url: '/api/v1/devices'
    });
};

/**
 * get one of my devices
 */
export const getDevice = <ThrowOnError extends boolean = false>(options: Options<GetDeviceData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetDeviceResponse, GetDeviceError, ThrowOnError>({
        ...options,
        url: '/api/v1/devices/{device_id}'
    });
};

/**
 * remove a device (revokes its token)
 */
export const deleteDevice = <ThrowOnError extends boolean = false>(options: Options<DeleteDeviceData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteDeviceResponse, DeleteDeviceError, ThrowOnError>({
        ...options,
        url: '/api/v1/devices/{device_id}'
    });
};

/**
 * mint a device token for a headless device agent
 * Issue the credential the Electron main process connects with.
 *
 * Enrolment is the one step that needs a signed-in human: the device
 * agent runs headless afterwards, so this is where the user says
 * "yes, that machine may act as me". Ownership is checked first —
 * ``device_id`` must already be a device of theirs.
 */
export const enrolDevice = <ThrowOnError extends boolean = false>(options: Options<EnrolDeviceData, ThrowOnError>) => {
    return (options?.client ?? client).post<EnrolDeviceResponse, EnrolDeviceError, ThrowOnError>({
        ...options,
        url: '/api/v1/devices/{device_id}:enrol'
    });
};

/**
 * list my skills
 */
export const listSkills = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<ListSkillsResponse, ListSkillsError, ThrowOnError>({
        ...options,
        url: '/api/v1/skills'
    });
};

/**
 * upload a SKILL.md
 */
export const uploadSkill = <ThrowOnError extends boolean = false>(options: Options<UploadSkillData, ThrowOnError>) => {
    return (options?.client ?? client).post<UploadSkillResponse, UploadSkillError, ThrowOnError>({
        ...options,
        url: '/api/v1/skills'
    });
};

/**
 * search skill registries
 */
export const searchSkillHub = <ThrowOnError extends boolean = false>(options: Options<SearchSkillHubData, ThrowOnError>) => {
    return (options?.client ?? client).get<SearchSkillHubResponse, SearchSkillHubError, ThrowOnError>({
        ...options,
        url: '/api/v1/skills/hub/search'
    });
};

/**
 * inspect a skill before installing
 */
export const previewHubSkill = <ThrowOnError extends boolean = false>(options: Options<PreviewHubSkillData, ThrowOnError>) => {
    return (options?.client ?? client).post<PreviewHubSkillResponse, PreviewHubSkillError, ThrowOnError>({
        ...options,
        url: '/api/v1/skills/hub/preview'
    });
};

/**
 * install a hub skill
 */
export const installSkill = <ThrowOnError extends boolean = false>(options: Options<InstallSkillData, ThrowOnError>) => {
    return (options?.client ?? client).post<InstallSkillResponse, InstallSkillError, ThrowOnError>({
        ...options,
        url: '/api/v1/skills/install'
    });
};

/**
 * uninstall a skill
 */
export const deleteSkill = <ThrowOnError extends boolean = false>(options: Options<DeleteSkillData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteSkillResponse, DeleteSkillError, ThrowOnError>({
        ...options,
        url: '/api/v1/skills/{skill_name}'
    });
};

/**
 * check pinned skills for updates
 */
export const listSkillUpdates = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<ListSkillUpdatesResponse, ListSkillUpdatesError, ThrowOnError>({
        ...options,
        url: '/api/v1/skills/updates'
    });
};

/**
 * list tools
 */
export const listTools = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<ListToolsResponse, ListToolsError, ThrowOnError>({
        ...options,
        url: '/api/v1/tools'
    });
};

/**
 * canonical tool manifest (Phase 12 §7.3)
 * Single source of truth for every tool consumer.
 *
 * Docs/development/12 §7.3 — the frontier prompt builder, the
 * sub-agent runtime, the dashboard tool picker, and the audit log
 * all read this endpoint instead of building their own views over
 * the registry. MCP-installed tools register through the same
 * :class:`ToolsRegistry` surface so they appear here at runtime
 * without a separate manifest call.
 */
export const getToolsManifest = <ThrowOnError extends boolean = false>(options?: Options<GetToolsManifestData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetToolsManifestResponse, GetToolsManifestError, ThrowOnError>({
        ...options,
        url: '/api/v1/tools/manifest'
    });
};

/**
 * get tool schema
 */
export const getTool = <ThrowOnError extends boolean = false>(options: Options<GetToolData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetToolResponse, GetToolError, ThrowOnError>({
        ...options,
        url: '/api/v1/tools/{tool_id}'
    });
};

/**
 * invoke a tool
 * Dispatch a tool. Two non-200 paths are wire-specific:
 *
 * * **409 confirmation_required** — the tool's confirmation policy
 * fired for these arguments (Docs/development/12 §7.2). The body
 * carries the rendered description, the canonical resume_schema, the
 * arguments that would run (after the pre-hooks) and a one-time
 * ``confirmation_token``. The caller asks the person and, on approval,
 * re-invokes with ``x-omni-confirmation: <token>``. The token is
 * bound to this user, tool and exact arguments, works once and
 * expires in minutes (:mod:`omni.modules.tools.consent`). An agent's
 * tool call never gets here — the dispatcher turns the same exception
 * into an Inbox approval.
 * * **400 / 404 / 422** — standard schema / not-found / unauth.
 *
 * ``x-omni-bypass-confirmation: true`` — the caller's word for *any*
 * arguments, so approving one email let a client send another — is
 * refused with 400 rather than ignored, so a stale client fails loudly
 * instead of looping on 409s (RW-1.19). The pre-hook chain runs either
 * way.
 */
export const invokeTool = <ThrowOnError extends boolean = false>(options: Options<InvokeToolData, ThrowOnError>) => {
    return (options?.client ?? client).post<InvokeToolResponse, InvokeToolError, ThrowOnError>({
        ...options,
        url: '/api/v1/tools/{tool_id}:invoke'
    });
};

/**
 * get tool run status
 */
export const getToolRun = <ThrowOnError extends boolean = false>(options: Options<GetToolRunData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetToolRunResponse, GetToolRunError, ThrowOnError>({
        ...options,
        url: '/api/v1/tools/runs/{run_id}'
    });
};

/**
 * cancel tool run
 */
export const cancelToolRun = <ThrowOnError extends boolean = false>(options: Options<CancelToolRunData, ThrowOnError>) => {
    return (options?.client ?? client).delete<CancelToolRunResponse, CancelToolRunError, ThrowOnError>({
        ...options,
        url: '/api/v1/tools/runs/{run_id}'
    });
};

/**
 * List Credentials
 */
export const listCredentials = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<ListCredentialsResponse, ListCredentialsError, ThrowOnError>({
        ...options,
        url: '/api/v1/me/credentials'
    });
};

/**
 * Create Credential
 */
export const createCredential = <ThrowOnError extends boolean = false>(options: Options<CreateCredentialData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateCredentialResponse, CreateCredentialError, ThrowOnError>({
        ...options,
        url: '/api/v1/me/credentials'
    });
};

/**
 * Delete Credential
 */
export const deleteCredential = <ThrowOnError extends boolean = false>(options: Options<DeleteCredentialData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteCredentialResponse, DeleteCredentialError, ThrowOnError>({
        ...options,
        url: '/api/v1/me/credentials/{credential_id}'
    });
};

/**
 * Get Model Options
 * The models users may pick in Settings → Models.
 *
 * Derived from the operator's configuration (``reasoning/models.py``), so
 * the list only offers models this deployment holds credentials for. When
 * an admin has turned selection off, ``user_selection_enabled`` is false,
 * the dashboard hides the section and ``PUT /model`` refuses. Signed-in
 * users only: the catalog names the models and vendors this deployment pays for.
 */
export const getModelOptions = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetModelOptionsResponse, GetModelOptionsError, ThrowOnError>({
        ...options,
        url: '/api/v1/me/preferences/model-options'
    });
};

/**
 * Get Model Preference
 */
export const getModelPreference = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetModelPreferenceResponse, GetModelPreferenceError, ThrowOnError>({
        ...options,
        url: '/api/v1/me/preferences/model'
    });
};

/**
 * Put Model Preference
 */
export const putModelPreference = <ThrowOnError extends boolean = false>(options: Options<PutModelPreferenceData, ThrowOnError>) => {
    return (options?.client ?? client).put<PutModelPreferenceResponse, PutModelPreferenceError, ThrowOnError>({
        ...options,
        url: '/api/v1/me/preferences/model'
    });
};

/**
 * Get Orchestration Preference
 * Read the user's pinned sub-agent budget defaults.
 *
 * Returns the user's stored values (or all-NULL when never set) plus
 * the *effective* values the engine will apply for any NULL slot —
 * so the UI can show ``effective_max_tokens=200000 (from settings)``
 * even when the user hasn't pinned a custom value.
 */
export const getOrchestrationPreference = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetOrchestrationPreferenceResponse, GetOrchestrationPreferenceError, ThrowOnError>({
        ...options,
        url: '/api/v1/me/preferences/orchestration'
    });
};

/**
 * Put Orchestration Preference
 * Pin the user's sub-agent budget defaults.
 *
 * All three knobs are NULL / 0 / positive-int — see the body schema.
 * The voice agent's ``core.spawn_agent`` tool reads these on every
 * spawn and bakes them onto the new ``AgentEntry`` row when no
 * explicit per-spawn override is supplied.
 */
export const putOrchestrationPreference = <ThrowOnError extends boolean = false>(options: Options<PutOrchestrationPreferenceData, ThrowOnError>) => {
    return (options?.client ?? client).put<PutOrchestrationPreferenceResponse, PutOrchestrationPreferenceError, ThrowOnError>({
        ...options,
        url: '/api/v1/me/preferences/orchestration'
    });
};

/**
 * Get Chat Preference
 */
export const getChatPreference = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetChatPreferenceResponse, GetChatPreferenceError, ThrowOnError>({
        ...options,
        url: '/api/v1/me/preferences/chat'
    });
};

/**
 * Put Chat Preference
 */
export const putChatPreference = <ThrowOnError extends boolean = false>(options: Options<PutChatPreferenceData, ThrowOnError>) => {
    return (options?.client ?? client).put<PutChatPreferenceResponse, PutChatPreferenceError, ThrowOnError>({
        ...options,
        url: '/api/v1/me/preferences/chat'
    });
};

/**
 * get my profile
 */
export const getMyProfile = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetMyProfileResponse, GetMyProfileError, ThrowOnError>({
        ...options,
        url: '/api/v1/me/profile'
    });
};

/**
 * update my profile
 */
export const putMyProfile = <ThrowOnError extends boolean = false>(options: Options<PutMyProfileData, ThrowOnError>) => {
    return (options?.client ?? client).put<PutMyProfileResponse, PutMyProfileError, ThrowOnError>({
        ...options,
        url: '/api/v1/me/profile'
    });
};

/**
 * my desktop, if any
 */
export const getDesktop = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetDesktopResponse, GetDesktopError, ThrowOnError>({
        ...options,
        url: '/api/v1/ride/desktop'
    });
};

/**
 * start a desktop (replaces any existing one)
 */
export const startDesktop = <ThrowOnError extends boolean = false>(options: Options<StartDesktopData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDesktopResponse, StartDesktopError, ThrowOnError>({
        ...options,
        url: '/api/v1/ride/desktop'
    });
};

/**
 * stop my desktop
 */
export const stopDesktop = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).delete<StopDesktopResponse, StopDesktopError, ThrowOnError>({
        ...options,
        url: '/api/v1/ride/desktop'
    });
};

/**
 * launch an application inside my desktop
 */
export const launchInDesktop = <ThrowOnError extends boolean = false>(options: Options<LaunchInDesktopData, ThrowOnError>) => {
    return (options?.client ?? client).post<LaunchInDesktopResponse, LaunchInDesktopError, ThrowOnError>({
        ...options,
        url: '/api/v1/ride/desktop/launch'
    });
};

/**
 * List Tiles
 */
export const listTiles = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<ListTilesResponse, ListTilesError, ThrowOnError>({
        ...options,
        url: '/api/v1/pane/tiles'
    });
};

/**
 * Create Tile
 */
export const createTile = <ThrowOnError extends boolean = false>(options: Options<CreateTileData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateTileResponse, CreateTileError, ThrowOnError>({
        ...options,
        url: '/api/v1/pane/tiles'
    });
};

/**
 * Clear Tiles
 * Remove every tile — or, with ``keep_pinned``, every unpinned one.
 */
export const clearTiles = <ThrowOnError extends boolean = false>(options?: Options<ClearTilesData, ThrowOnError>) => {
    return (options?.client ?? client).delete<ClearTilesResponse, ClearTilesError, ThrowOnError>({
        ...options,
        url: '/api/v1/pane/tiles'
    });
};

/**
 * Update Tile
 */
export const updateTile = <ThrowOnError extends boolean = false>(options: Options<UpdateTileData, ThrowOnError>) => {
    return (options?.client ?? client).patch<UpdateTileResponse, UpdateTileError, ThrowOnError>({
        ...options,
        url: '/api/v1/pane/tiles/{tile_id}'
    });
};

/**
 * Delete Tile
 */
export const deleteTile = <ThrowOnError extends boolean = false>(options: Options<DeleteTileData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteTileResponse, DeleteTileError, ThrowOnError>({
        ...options,
        url: '/api/v1/pane/tiles/{tile_id}'
    });
};

/**
 * Pane Events
 * Server-Sent Events stream of pane changes for the calling user.
 *
 * The dashboard reads it with ``fetch`` (bearer in the header) on
 * mount and re-reads ``GET /tiles`` on every (re)connect, because
 * the bridge does not replay events sent while it was away. Each
 * tile create / update / delete / clear is one JSON event.
 * Heartbeats every 15 seconds keep proxies from closing the
 * connection.
 */
export const paneEvents = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<PaneEventsResponse, PaneEventsError, ThrowOnError>({
        ...options,
        url: '/api/v1/pane/events'
    });
};

/**
 * list my projects
 */
export const listProjects = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<ListProjectsResponse, ListProjectsError, ThrowOnError>({
        ...options,
        url: '/api/v1/projects'
    });
};

/**
 * create a project
 */
export const createProject = <ThrowOnError extends boolean = false>(options: Options<CreateProjectData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateProjectResponse, CreateProjectError, ThrowOnError>({
        ...options,
        url: '/api/v1/projects'
    });
};

/**
 * get a project
 */
export const getProject = <ThrowOnError extends boolean = false>(options: Options<GetProjectData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetProjectResponse, GetProjectError, ThrowOnError>({
        ...options,
        url: '/api/v1/projects/{project_id}'
    });
};

/**
 * rename a project or edit its instructions
 */
export const updateProject = <ThrowOnError extends boolean = false>(options: Options<UpdateProjectData, ThrowOnError>) => {
    return (options?.client ?? client).patch<UpdateProjectResponse, UpdateProjectError, ThrowOnError>({
        ...options,
        url: '/api/v1/projects/{project_id}'
    });
};

/**
 * delete a project
 * Its chats move back to the general list, its memory is forgotten and its
 * file links dropped; the files themselves stay in Files.
 */
export const deleteProject = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteProjectResponse, DeleteProjectError, ThrowOnError>({
        ...options,
        url: '/api/v1/projects/{project_id}'
    });
};

/**
 * list a project's files
 */
export const listProjectFiles = <ThrowOnError extends boolean = false>(options: Options<ListProjectFilesData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListProjectFilesResponse, ListProjectFilesError, ThrowOnError>({
        ...options,
        url: '/api/v1/projects/{project_id}/files'
    });
};

/**
 * add one of my files to a project
 */
export const addProjectFile = <ThrowOnError extends boolean = false>(options: Options<AddProjectFileData, ThrowOnError>) => {
    return (options?.client ?? client).post<AddProjectFileResponse, AddProjectFileError, ThrowOnError>({
        ...options,
        url: '/api/v1/projects/{project_id}/files'
    });
};

/**
 * remove a file from a project
 * Unlinks only: the file stays in the user's Files.
 */
export const removeProjectFile = <ThrowOnError extends boolean = false>(options: Options<RemoveProjectFileData, ThrowOnError>) => {
    return (options?.client ?? client).delete<RemoveProjectFileResponse, RemoveProjectFileError, ThrowOnError>({
        ...options,
        url: '/api/v1/projects/{project_id}/files/{artifact_id}'
    });
};

/**
 * MCP catalog
 */
export const getMcpCatalog = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetMcpCatalogResponse, GetMcpCatalogError, ThrowOnError>({
        ...options,
        url: '/api/v1/mcp/catalog'
    });
};

/**
 * my installed MCPs
 */
export const listInstalledMcps = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<ListInstalledMcpsResponse, ListInstalledMcpsError, ThrowOnError>({
        ...options,
        url: '/api/v1/mcp'
    });
};

/**
 * install an MCP
 */
export const installMcp = <ThrowOnError extends boolean = false>(options: Options<InstallMcpData, ThrowOnError>) => {
    return (options?.client ?? client).post<InstallMcpResponse, InstallMcpError, ThrowOnError>({
        ...options,
        url: '/api/v1/mcp:install'
    });
};

/**
 * uninstall an MCP
 */
export const uninstallMcp = <ThrowOnError extends boolean = false>(options: Options<UninstallMcpData, ThrowOnError>) => {
    return (options?.client ?? client).delete<UninstallMcpResponse, UninstallMcpError, ThrowOnError>({
        ...options,
        url: '/api/v1/mcp/{mcp_id}'
    });
};

/**
 * reload an MCP
 */
export const reloadMcp = <ThrowOnError extends boolean = false>(options: Options<ReloadMcpData, ThrowOnError>) => {
    return (options?.client ?? client).post<ReloadMcpResponse, ReloadMcpError, ThrowOnError>({
        ...options,
        url: '/api/v1/mcp/{mcp_id}:reload'
    });
};

/**
 * Get Voice Status
 */
export const getVoiceStatus = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetVoiceStatusResponse, GetVoiceStatusError, ThrowOnError>({
        ...options,
        url: '/api/v1/voice'
    });
};

/**
 * Start Call
 */
export const startVoiceCall = <ThrowOnError extends boolean = false>(options: Options<StartVoiceCallData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartVoiceCallResponse, StartVoiceCallError, ThrowOnError>({
        ...options,
        url: '/api/v1/voice/calls'
    });
};

/**
 * Start Device Call
 * A device (no screen, no user session) starts a call with its device token.
 *
 * The device acts as its owner and nothing more — the same credential the
 * desktop agent uses (``devices/tokens.py``). A deleted device is refused,
 * so deleting it in the dashboard revokes it. Each device talks in its own
 * chat session (``device-<id>``), visible in the owner's chat list.
 */
export const startDeviceVoiceCall = <ThrowOnError extends boolean = false>(options?: Options<StartDeviceVoiceCallData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDeviceVoiceCallResponse, StartDeviceVoiceCallError, ThrowOnError>({
        ...options,
        url: '/api/v1/voice/device-calls'
    });
};

/**
 * Negotiate WebRTC media tier
 * Mint ephemeral TURN credentials and return the media-plane SDP answer.
 *
 * The media plane (SFU / relay) is read from ``app.state.rtc_media`` if wired.
 * When absent we 503 so the client transparently stays on the WS binary tier —
 * WebRTC is strictly an optimisation, never a hard dependency.
 */
export const rtcOffer = <ThrowOnError extends boolean = false>(options: Options<RtcOfferData, ThrowOnError>) => {
    return (options?.client ?? client).post<RtcOfferResponse2, RtcOfferError, ThrowOnError>({
        ...options,
        url: '/api/v1/rtc/offer'
    });
};

/**
 * List pending HITL input requests
 */
export const listInputs = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<ListInputsResponse, ListInputsError, ThrowOnError>({
        ...options,
        url: '/api/v1/inputs'
    });
};

/**
 * Resolve a pending HITL input request
 */
export const resolveInput = <ThrowOnError extends boolean = false>(options: Options<ResolveInputData, ThrowOnError>) => {
    return (options?.client ?? client).post<ResolveInputResponse, ResolveInputError, ThrowOnError>({
        ...options,
        url: '/api/v1/inputs/{request_id}:resolve'
    });
};

/**
 * List the caller's notifications
 */
export const listNotifications = <ThrowOnError extends boolean = false>(options?: Options<ListNotificationsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListNotificationsResponse, ListNotificationsError, ThrowOnError>({
        ...options,
        url: '/api/v1/notifications'
    });
};

/**
 * Mark a notification as read
 */
export const markNotificationRead = <ThrowOnError extends boolean = false>(options: Options<MarkNotificationReadData, ThrowOnError>) => {
    return (options?.client ?? client).post<MarkNotificationReadResponse, MarkNotificationReadError, ThrowOnError>({
        ...options,
        url: '/api/v1/notifications/{notification_id}:read'
    });
};

/**
 * Get the caller's notification preferences
 */
export const getPreferences = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetPreferencesResponse, GetPreferencesError, ThrowOnError>({
        ...options,
        url: '/api/v1/notifications/preferences'
    });
};

/**
 * Update the caller's notification preferences
 * Replace the caller's preferences. ``enabled_channels`` is keyed by
 * notification kind; a channel with no transport here is a 422.
 */
export const patchPreferences = <ThrowOnError extends boolean = false>(options: Options<PatchPreferencesData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PatchPreferencesResponse, PatchPreferencesError, ThrowOnError>({
        ...options,
        url: '/api/v1/notifications/preferences'
    });
};

/**
 * Browser push settings
 * Whether ``web_push`` is wired here, and the VAPID public key a
 * browser passes to ``pushManager.subscribe``.
 */
export const getPushConfig = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetPushConfigResponse, GetPushConfigError, ThrowOnError>({
        ...options,
        url: '/api/v1/notifications/push'
    });
};

/**
 * Subscribe this browser to push notifications
 * Store the browser's ``PushSubscription``. The endpoint must be a known
 * push service (the server POSTs to it); a refused one is a 400.
 */
export const subscribePush = <ThrowOnError extends boolean = false>(options: Options<SubscribePushData, ThrowOnError>) => {
    return (options?.client ?? client).post<SubscribePushResponse, SubscribePushError, ThrowOnError>({
        ...options,
        url: '/api/v1/notifications/push:subscribe'
    });
};

/**
 * Stop push notifications to this browser
 * Idempotent: an endpoint that is not the caller's is left alone.
 */
export const unsubscribePush = <ThrowOnError extends boolean = false>(options: Options<UnsubscribePushData, ThrowOnError>) => {
    return (options?.client ?? client).post<UnsubscribePushResponse, UnsubscribePushError, ThrowOnError>({
        ...options,
        url: '/api/v1/notifications/push:unsubscribe'
    });
};

/**
 * Create a new RIDE session
 */
export const createRideSession = <ThrowOnError extends boolean = false>(options: Options<CreateRideSessionData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateRideSessionResponse, CreateRideSessionError, ThrowOnError>({
        ...options,
        url: '/api/v1/ride/sessions'
    });
};

/**
 * List the caller's RIDE sessions
 */
export const listRideSessions = <ThrowOnError extends boolean = false>(options?: Options<ListRideSessionsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListRideSessionsResponse, ListRideSessionsError, ThrowOnError>({
        ...options,
        url: '/api/v1/ride/sessions'
    });
};

/**
 * Fetch a RIDE session
 */
export const getRideSession = <ThrowOnError extends boolean = false>(options: Options<GetRideSessionData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetRideSessionResponse, GetRideSessionError, ThrowOnError>({
        ...options,
        url: '/api/v1/ride/sessions/{session_id}'
    });
};

/**
 * Cancel a running RIDE session
 */
export const cancelRideSession = <ThrowOnError extends boolean = false>(options: Options<CancelRideSessionData, ThrowOnError>) => {
    return (options?.client ?? client).post<CancelRideSessionResponse, CancelRideSessionError, ThrowOnError>({
        ...options,
        url: '/api/v1/ride/sessions/{session_id}:cancel'
    });
};

/**
 * Retry a failed step
 */
export const retryRideStep = <ThrowOnError extends boolean = false>(options: Options<RetryRideStepData, ThrowOnError>) => {
    return (options?.client ?? client).post<RetryRideStepResponse, RetryRideStepError, ThrowOnError>({
        ...options,
        url: '/api/v1/ride/sessions/{session_id}/steps/{step_id}:retry'
    });
};

/**
 * List the caller's workflows
 */
export const listWorkflows = <ThrowOnError extends boolean = false>(options?: Options<ListWorkflowsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListWorkflowsResponse, ListWorkflowsError, ThrowOnError>({
        ...options,
        url: '/api/v1/workflows'
    });
};

/**
 * Create a workflow
 */
export const createWorkflow = <ThrowOnError extends boolean = false>(options: Options<CreateWorkflowData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateWorkflowResponse, CreateWorkflowError, ThrowOnError>({
        ...options,
        url: '/api/v1/workflows'
    });
};

/**
 * Update a workflow
 */
export const updateWorkflow = <ThrowOnError extends boolean = false>(options: Options<UpdateWorkflowData, ThrowOnError>) => {
    return (options?.client ?? client).patch<UpdateWorkflowResponse, UpdateWorkflowError, ThrowOnError>({
        ...options,
        url: '/api/v1/workflows/{workflow_id}'
    });
};

/**
 * Delete a workflow
 */
export const deleteWorkflow = <ThrowOnError extends boolean = false>(options: Options<DeleteWorkflowData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteWorkflowResponse, DeleteWorkflowError, ThrowOnError>({
        ...options,
        url: '/api/v1/workflows/{workflow_id}'
    });
};

/**
 * Manually fire a workflow
 */
export const triggerWorkflow = <ThrowOnError extends boolean = false>(options: Options<TriggerWorkflowData, ThrowOnError>) => {
    return (options?.client ?? client).post<TriggerWorkflowResponse, TriggerWorkflowError, ThrowOnError>({
        ...options,
        url: '/api/v1/workflows/{workflow_id}:trigger'
    });
};

/**
 * List runs for a workflow
 */
export const listWorkflowRuns = <ThrowOnError extends boolean = false>(options: Options<ListWorkflowRunsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListWorkflowRunsResponse, ListWorkflowRunsError, ThrowOnError>({
        ...options,
        url: '/api/v1/workflows/{workflow_id}/runs'
    });
};

/**
 * Get one workflow run
 */
export const getWorkflowRun = <ThrowOnError extends boolean = false>(options: Options<GetWorkflowRunData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetWorkflowRunResponse, GetWorkflowRunError, ThrowOnError>({
        ...options,
        url: '/api/v1/workflows/runs/{run_id}'
    });
};

/**
 * List per-step audit rows for one run
 */
export const listWorkflowRunSteps = <ThrowOnError extends boolean = false>(options: Options<ListWorkflowRunStepsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListWorkflowRunStepsResponse, ListWorkflowRunStepsError, ThrowOnError>({
        ...options,
        url: '/api/v1/workflows/runs/{run_id}/steps'
    });
};

/**
 * Validate a WorkflowDefinition without saving
 */
export const validateWorkflow = <ThrowOnError extends boolean = false>(options: Options<ValidateWorkflowData, ThrowOnError>) => {
    return (options?.client ?? client).post<ValidateWorkflowResponse, ValidateWorkflowError, ThrowOnError>({
        ...options,
        url: '/api/v1/workflows/validate'
    });
};

/**
 * Generate a WorkflowDefinition from a plain-language prompt
 */
export const generateWorkflow = <ThrowOnError extends boolean = false>(options: Options<GenerateWorkflowData, ThrowOnError>) => {
    return (options?.client ?? client).post<GenerateWorkflowResponse, GenerateWorkflowError, ThrowOnError>({
        ...options,
        url: '/api/v1/workflows/generate'
    });
};

/**
 * Public Status
 */
export const publicStatus = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<PublicStatusResponse, PublicStatusError, ThrowOnError>({
        ...options,
        url: '/api/v1/status'
    });
};

/**
 * Admin Slos
 */
export const adminSlos = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminSlosResponse, AdminSlosError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/slos'
    });
};

/**
 * Admin Costs
 */
export const adminCosts = <ThrowOnError extends boolean = false>(options?: Options<AdminCostsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminCostsResponse, AdminCostsError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/costs'
    });
};

/**
 * Admin Audit
 * The audit trail, newest first — the one read route. Admin actions
 * are ``admin.*`` (the policies router used to serve its own table at
 * this same path, which shadowed this one).
 */
export const adminAudit = <ThrowOnError extends boolean = false>(options?: Options<AdminAuditData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminAuditResponse, AdminAuditError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/audit'
    });
};

/**
 * Verify Audit Chain
 * Walk the audit hash chain and report the first broken link (FA-4b).
 *
 * Reads the whole chain, a page at a time: run it on demand or from
 * ``scripts/verify_audit_chain.py`` on a schedule, not on every page view.
 */
export const verifyAuditChain = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<VerifyAuditChainResponse, VerifyAuditChainError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/audit:verify'
    });
};

/**
 * Admin Profile
 */
export const adminProfile = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminProfileResponse, AdminProfileError, ThrowOnError>({
        ...options,
        url: '/api/v1/admin/profile'
    });
};

/**
 * Webhook Agent Done
 * Resume a sub-agent with the result of an external long-running task.
 *
 * The actual resumption runs in a background task — the response
 * returns ``202 Accepted`` immediately so the external caller is not
 * blocked while the sub-agent processes the result.
 */
export const webhookAgentDone = <ThrowOnError extends boolean = false>(options?: Options<WebhookAgentDoneData, ThrowOnError>) => {
    return (options?.client ?? client).post<WebhookAgentDoneResponse, WebhookAgentDoneError, ThrowOnError>({
        ...options,
        url: '/api/v1/webhooks/agent_done'
    });
};

/**
 * List Agents
 * Return the live registry parsed into buckets — store-backed read.
 */
export const listOrchestrationAgents = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<ListOrchestrationAgentsResponse, ListOrchestrationAgentsError, ThrowOnError>({
        ...options,
        url: '/api/v1/orchestration/agents'
    });
};

/**
 * Get Agent Wiki
 * Return the full ``task.md`` for one agent — artifact read.
 *
 * Verifies the agent exists in the user's registry first (so a
 * successful 200 implies "this is your agent"), then loads the wiki
 * artifact. Returns ``{found: false, ...}`` (still 200) when the
 * wiki hasn't been materialised yet — dashboard renders that
 * inline rather than treating it as a hard error.
 */
export const getAgentWiki = <ThrowOnError extends boolean = false>(options: Options<GetAgentWikiData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAgentWikiResponse, GetAgentWikiError, ThrowOnError>({
        ...options,
        url: '/api/v1/orchestration/agents/{agent_id}'
    });
};